import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = fetchData; // Update to use the correct path to your data

  const formattedData = useMemo(() => {
    const rows = [];

    if (data && Array.isArray(data)) {
      data.forEach((item, index) => {
        const role = item.Role;
        const company = item.Company;
        const companyPackages = company.CompanyPackages || []; // Ensure it's an array

        // Initialize package flags
        let package_type1 = "-";
        let package_type2 = "-";
        let package_type3 = "-";

        companyPackages.forEach((pkg) => {
          if (pkg.package_type_id === 1) {
            package_type1 = role.name;
          } else if (pkg.package_type_id === 2) {
            package_type2 = role.name;
          } else if (pkg.package_type_id === 3) {
            package_type3 = role.name;
          }
        });

        const row = {
          index: index + 1,
          id: item.user_id,
          username: item.username,
          name: item.name,
          image: item.image,
          owner: item.owner ? item.owner : "-", // Correct owner access
          company_name: company.company_name,
          created_date: moment(item.created_date).format(
            "DD/MM/YYYY\n เวลา HH:mm:ss น."
          ),
          updated_date: moment(item.updated_date).format(
            "DD/MM/YYYY\n เวลา HH:mm:ss น."
          ),
          status: item.status,
          approved: item.approved,
          package_type1, // true if package 1 exists
          package_type2, // true if package 2 exists
          package_type3, // true if package 3 exists
        };

        rows.push(row);

        // console.log("row", row);
      });
    }

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
